module.exports = __webpack_public_path__ + "img/tintuc20.e7bad990.png";